import React from 'react'
import { Tooltip, Modal } from 'antd'
import { useState, useEffect } from 'react'
import { Upload, message, Button, Row, Col, Input, Form, Select } from 'antd'
import { UploadOutlined, InboxOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import Layouts from '../src/components/Layouts'
import axios from 'axios'
import { DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { saveAs } from 'file-saver'
import ViewPolicyClaim from './ViewPolicy'
import apiRequest from './hooks/apiRequest'
import { toast } from 'react-toastify'
const { Option } = Select
function GenerateAssessorReport(props) {
  const [claimData, setClaimData] = useState()
  const [loading, setLoading] = useState(false)
  const [selectedFile, setSelectedFile] = useState()
  const [uploadedDoc, setUploadedDoc] = useState([])
  const [assessorReportFound, setAssessorReportFound] = useState(true)
  const [viewPolicy, setViewPolicy] = useState(false)
  const [policyData, setPolicyData] = useState({
    policyNumber: '',
    customerName: '',
    nationalId: '',
    policyStartDate: '',
    policyEndDate: '',
    proRataPremium: '',
    productName: '',
    policyRiskItems: '',
    vrnNo: '',
  })
  const [limit, setLimit] = useState();
  const [accessorId, setaccessorId] = useState()
  const [assessorsList, setAssessorsList] = useState()
  const [assessorName, setAssessorName] = useState()
  const [isSubmitAllowed, setIsSubmitAllowed] = useState(false)

  const fetchLimit = async () => {
    try {
      const response = await apiRequest(`${process.env.REACT_APP_BASE_URL_AUTH}/api/Settings/all`, 'GET')

      if (response.success) {
        setLimit(response.data);
        console.log(response.data);
      }
    } catch (error) {
      console.error('Error fetching limits:', error);
    }
  }

  const fetchUserList = async () => {
    try {

      // debugger
      const storedRoleId = JSON.parse(localStorage.getItem('user'));
      let filteredUsers;
      console.log('storedRoleId', storedRoleId)
      const roleID = parseInt(storedRoleId?.role) + 1;
      localStorage.setItem("roleID", roleID);
      if (!storedRoleId) {
        console.error('Role ID not found in localStorage');
        return;
      }
      // const roleId = parseInt(storedRoleId); // convert to number
      const response = await apiRequest(
        `https://outoversite.kindlebit.com/api/Auth/GetAllClaimUsersByInsurerId?insurerid=248`,
        'GET'
      );

      if (storedRoleId?.role == 313 || storedRoleId?.role === 314) {
        filteredUsers = response?.data?.filter(user => user.roleId == roleID);
        setAssessorsList(filteredUsers || []);
      }

      console.log('==>', filteredUsers);
    } catch (error) {
      console.error('Error fetching or filtering users:', error);
    }
  }

  const checkAllowed = async () => {
    // debugger
    console.log(claimData);
    const user = JSON.parse(localStorage.getItem('user'));
    const storedRoleId = parseInt(user?.role, 10); // convert to number

    const myLimit = limit.find(res => res.roleId === storedRoleId);

    if(claimData.claim_amount < myLimit.upperLimit)
    {
      setIsSubmitAllowed(true);
    }
  }

  useEffect(() => {
    const fetchClaimInfo = async () => {
      setLoading(true);
      const claimId = localStorage.getItem('claimId');

      try {
        // Get claim data
        const claimRes = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/claim/GetClaimById/${claimId}`,
          'GET'
        );
        const claimResult = claimRes?.data?.result?.claim_creation;
        if (claimResult) {
          setClaimData(claimResult);
        }

        console.log('Claim data in report', claimResult);

        // Get claim quotation
        const quotationRes = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/claim/GetClaimQuotation/${claimId}`,
          'GET'
        );
        console.log('quotationRes', quotationRes?.data)
        const quotationData = quotationRes?.data || [];
        setUploadedDoc(quotationData);

        // Check if Assessor Report is found
        const hasAssessorReport = quotationData.some(
          doc => doc.filename === 'Assesors Report'
        );
        // setAssessorReportFound(hasAssessorReport);

      } catch (error) {
        console.error('Error fetching claim details or quotation:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClaimInfo();
    fetchLimit();
    fetchUserList();
    // checkAllowed();
  }, []);

  useEffect(() => {
    if (limit && Array.isArray(limit) && claimData) {
      checkAllowed();
    }
  }, [limit, claimData]);

  function handleChangeAccessor(value, option) {
    setaccessorId(parseInt(value))
    setAssessorName(option.props.fullName)
  }

  function ViewPolicyF(val) {
    let apiData
    let productId
    setLoading(true)
    if (val.includes('OTM')) {
      fetch('http://64.227.72.205:5001/api/v1/policy/' + val)
        .then(res => res.json())
        .then(data => {
          apiData = {
            productName: 'Motor Insurance',
            policyNo: data.policy_number,
            policyStartDate: data.policy_start_date,
            policyEndDate: data.policy_end_date,
            sumInsured: data.sum_insured,
            customerName: data.first_name + ' ' + data.surname,
            riskItemDetails: '',
            vrn: data.vrn,
          }
          setLoading(false)
          setPolicyData(apiData)
          setViewPolicy(true)
        })
    } else {
      if (val.includes('OTAAR')) {
        productId = 1
      } else if (val.includes('OTDC')) {
        productId = 2
      } else if (val.includes('OTFCP')) {
        productId = 3
      }
      fetch(
        process.env.REACT_APP_BASE_URL_POLICIES +
        //process.env.REACT_APP_BASE_URL +
        '/Policy/GetPolicybynumber/' +
        val +
        ',' +
        productId,
      )
        .then(res => res.json())
        .then(data => {
          apiData = {
            productName: data.policydetail.productname,
            policyNo: data.policydetail.policynumber,
            policyStartDate: data.policydetail.policystartdate,
            policyEndDate: data.policydetail.policyexpirytdate,
            sumInsured: '',
            customerName: data.policydetail.customername,
            riskItemDetails: data.policydetail.riskitemdetails,
          }
          setLoading(false)
          setPolicyData(apiData)
          setViewPolicy(true)
        })
    }
  }

  // for (var i = 0; i <= uploadedDoc.length; i++) {
  //   if (uploadedDoc[i].filename === 'PoliceFile') {
  //     setAssessorReportFound(true)
  //   }
  // }
  function onFileChange(event) {
    setSelectedFile(event.target.files[0])
  }

  function setVisibleFalse() {
    setViewPolicy(false)
  }

  function onFileUpload() {
    // var file = new FormData()
    // file.append('claim_id', parseInt(localStorage.getItem('claimId')))
    // file.append('claim_number', claimData.claim_number)
    // file.append('policy_number', claimData.policy_number)
    // file.append('filename', 'Assesors Report')
    // file.append('FormFile', selectedFile)
    // file.append('doc_path', 'mmjjkk')
    // axios
    //   .post('http://196.43.101.15:7033/Claim/ClaimDocuments', file)
    //   .then(data => {
    //     if (data.status === 201) {
    //       message.success('Document uploaded successfully')
    //       window.location.reload()
    //     } else {
    //       message.error('Document upload Failed')
    //     }
    //   })

    toast.success('Document uploaded successfully!');

  }

  function downloadFile(val) {
    saveAs(val, 'AssessorReport')
  }

  // const handleSubmit = e => {
  //   debugger
  //   setLoading(true)
  //   e.preventDefault()
  //   props.form.validateFields((err, values) => {
  //     if (!err) {
  //       claimData.approved_amount = parseFloat(values.approved_amount)
  //       claimData.claim_status = 'Awaiting Authorisation'
  //       claimData.claim_notes = values.claim_notes
  //       claimData.user_name = localStorage.getItem('username')
  //       claimData.user_id = localStorage.getItem('loggedInUserID')
  //       const requestMetadata = {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify(claimData),
  //       }
  //       fetch(
  //         process.env.REACT_APP_BASE_URL + '/claim/CreateClaim',
  //         requestMetadata,
  //       )
  //         .then(res => res.json())
  //         .then(data => {
  //           if (data.responseStatus === true) {
  //             message.success('Claim Updated Successfully')
  //             window.location.href = '/claims'
  //             setLoading(false)
  //           } else {
  //             message.error('Claim Updation Failed')
  //             setLoading(false)
  //           }
  //         })
  //     }
  //   })
  // }

  const handleEscalate = async () => {
    const req_body = {
      claimId: claimData.id,
      accesorId: accessorId,
      accesorName: assessorName,
      claimStatus: claimData.claim_status,
    }

    const response = await apiRequest(process.env.REACT_APP_BASE_URL + '/Claim/UpdateAccessor/update-accessor', 'POST', req_body)

    if (response.success) {
      toast.success(`Claim Escalated Sucessfully`);
      window.location.href = '/claims';
      // props.closeModale();
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const values = await props.form.validateFields();

      claimData.approved_amount = parseFloat(values.approved_amount);
      claimData.claim_status = 'Approved';
      claimData.claim_notes = values.claim_notes;

      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + `/Claim/UpdateClaim/update`,
        'POST',
        claimData
      );

      if (response.success) {
        // console.log("Validation updated successfully!");
        toast.success('Report Submitted Successfully');
        window.location.href = '/claims';
      } else {
        message.error('Claim Updation Failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error('An error occurred while updating the claim');
    } finally {
      setLoading(false);
    }
  };


  const { getFieldDecorator } = props.form

  console.log(isSubmitAllowed);

  return (
    <>
      <Layouts title="assets" classname="grid">
        <Spin
          className="loader-icon-fixed"
          spinning={loading}
          size="large"></Spin>
        <div className=" dash-bg-white">
          <Row gutter={4}>
            <Col xs={12} sm={24} md={12} lg={24}>
              <h2
                style={{
                  color: '#F15A2B',
                  fontWeight: '500',
                  fontSize: '20px',
                  marginBottom: '0',
                }}>
                <strong>
                  Claim Details{' '}
                  <label
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                    }}></label>
                </strong>
              </h2>
            </Col>
          </Row>
          <Row gutter={[16, 24]} style={{ display: 'inline' }}>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Customer Name : </b> {claimData && claimData.customer_name}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Claim No. : </b> {claimData && claimData.claim_number}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Policy No. : </b>
                {claimData && claimData.policy_number}
              </label>
              <Tooltip title="View Policy Details">
                <InfoCircleOutlined
                  style={{
                    position: 'relative',
                    zIndex: '999',
                    marginLeft: '10px',
                    color: '#29b0e5',
                  }}
                  onClick={() => ViewPolicyF(claimData.policy_number)}
                />
              </Tooltip>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Date of Loss : </b>
                {claimData && claimData.date_of_loss}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Date of Notification :</b>{' '}
                {claimData && claimData.date_of_notification}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Claim Amount : </b>
                {claimData && claimData.claim_amount}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Claim Status : </b>
                {claimData && claimData.claim_status}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Assigned To : </b>
                {claimData && claimData.accessor_name}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Item Detail :</b> {claimData && claimData.itemdetails}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Approved Amount :</b>{' '}
                {claimData && claimData.approved_amount}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Damage Description :</b>{' '}
                {claimData && claimData.damage_description}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Approved Amount Notes :</b>{' '}
                {claimData && claimData.claim_notes}
              </label>
            </Col>
          </Row>
        </div>
        <div className="dash-bg-white">
          <div className="section-top-heading">
            <h3
              style={{
                color: '#F15A2B',
                fontWeight: '700',
                fontSize: '20px',
                margin: '0',
                marginBottom: '20px',
              }}>
              {' '}
              Assessors Report{' '}
            </h3>
          </div>
          {uploadedDoc.length !== 0 && (
            <div>
              <ul>
                {uploadedDoc.map(uploadedDocs => {
                  return (
                    <div>
                      {uploadedDocs.filename === 'Assesors Report' && (
                        <label>
                          <b>
                            {uploadedDocs.doc_path.slice(40)}
                            <br />
                            <DownloadOutlined
                              style={{ color: 'green' }}
                              onClick={() =>
                                downloadFile(uploadedDocs.doc_path)
                              }
                            />
                          </b>
                        </label>
                      )}
                    </div>
                  )
                })}
              </ul>
            </div>
          )}
          <div>
            <input type="file" multiple onChange={onFileChange} />
            <div className="add-button">
              <Button
                htmlType="submit"
                size="default"
                className="primary m-t-0 w-50"
                onClick={onFileUpload}>
                Upload
              </Button>
            </div>
          </div>
        </div>
        {isSubmitAllowed && (
          <div className="dash-bg-white">
            <div className="section-top-heading">
              <Form
                id="my-form"
                onSubmit={e => {
                  handleSubmit(e)
                }}>
                <Row gutter={[16, 24]}>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item label="Approved Amount">
                      {getFieldDecorator('approved_amount', {
                        rules: [
                          {
                            required: true,
                            message: 'Please input Claim Amount!',
                            whitespace: false,
                          },
                        ],
                      })(<Input placeholder="Approved Amount" />)}
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={6}>
                    <Form.Item label="Approved Amount Description">
                      {getFieldDecorator('claim_notes', {
                        rules: [
                          {
                            required: true,
                            message:
                              'Please input Approved Amount Description!',
                            whitespace: false,
                          },
                        ],
                      })(
                        <Input.TextArea
                          rows="6"
                          style={{ height: '100px' }}
                          placeholder="Description"
                        />,
                      )}
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={24}>
                    <div className="add-button">
                      <Button
                        htmlType="submit"
                        size="default"
                        className="primary m-t-0 w-50">
                        Submit
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        )}

        {!isSubmitAllowed ? (
          <div className="dash-bg-white">
            <div>
              <Select
                // placeholder="--Assign Assessor--"
                placeholder={`--Assign ${localStorage.getItem('ModalTitle')}--`}
                name="mode_of_notification"
                onChange={handleChangeAccessor}>
                {assessorsList &&
                  assessorsList.map(x => (
                    <Option key={x.userId} value={x.userId} fullName={`${x.firstName} ${x.lastName}`}>
                      {`${x?.firstName} ${x?.lastName}`}
                    </Option>
                  ))}
              </Select>
            </div>
            <div className="add-button" style={{ marginTop: '25px' }}>
              <Button
                onClick={handleEscalate}
                size="default"
                className="primary m-t-0 w-50">
                Assign
              </Button>
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <Modal
          title={
            <h3
              style={{
                color: '#F15A2B',
                fontWeight: '700',
                fontSize: '20px',
                margin: '0',
              }}>
              Policy Details
            </h3>
          }
          centered
          visible={viewPolicy}
          footer={null}
          onCancel={setVisibleFalse}
          width={1200}>
          <ViewPolicyClaim parentToChild={policyData} />
        </Modal>
      </Layouts>
    </>
  )
}

export default Form.create()(GenerateAssessorReport)
